import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import TheatreSidebar from "../Layouts/TheatreSidebar";

import axios from "axios";
import $ from "jquery";

export class IntraOperativeTourniquetDrain extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      Site: "",
      Pressure: "",
      Timeon: "",
      TimeOff: "",
      SkinCheckedBefore: "",
      SkinCheckedAfter: "",
      DrainType: "",
      WoundIrrigation: "",
      WoundpackType: "",
      WoundpackSite: "",

      // 				visitid = request.headers["visitid"],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    $(".deadonehouryes").click(function () {
      $(".deadonereason").show();
    });
    $(".deadonehourno").click(function () {
      $(".deadonereason").hide();
    });

    $(".stillbirthyes").click(function () {
      $(".stillbirthtype").show();
    });
    $(".stillbirthno").click(function () {
      $(".stillbirthtype").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
      surgeryid: localStorage.getItem("surgeryid"),
    };
    event.preventDefault();
    console.log(this.state);
    axios
      .post(
        this.api_url+"optheatre/operativeorders/intra/optheatre/tourniquetdrain",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          $(".alert-success").show();
        }

        setTimeout(function () {
          window.location.href = "/theatre/intra/op/wound/tranfusion";
        }, 500);

        //
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const {
      Site,
      Pressure,
      Timeon,
      TimeOff,
      SkinCheckedBefore,
      SkinCheckedAfter,
      DrainType,
      WoundIrrigation,
      WoundpackType,
      WoundpackSite,
    } = this.state;
    return (
      <div>
        <Headers />
        <TheatreSidebar />

        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2"></div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    IntraOperative Entry
                  </p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Site
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={Site}
                      name="Site"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Pressure
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Pressure}
                      name="Pressure"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Timeon
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Timeon}
                      name="Timeon"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      TimeOff
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={TimeOff}
                      name="TimeOff"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      SkinCheckedBefore
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={SkinCheckedBefore}
                      name="SkinCheckedBefore"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      SkinCheckedAfter
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={SkinCheckedAfter}
                      name="SkinCheckedAfter"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      DrainType
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={DrainType}
                      name="DrainType"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      WoundIrrigation
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={WoundIrrigation}
                      name="WoundIrrigation"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      WoundpackType
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={WoundpackType}
                      name="WoundpackType"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      WoundpackSite
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={WoundpackSite}
                      name="WoundpackSite"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default IntraOperativeTourniquetDrain;
